<template>
  <q-page padding class="column" :style-fn="heightTweak">
    <div class="col-xs-2 col-md-1 row justify-between items-center">
      <div class="col-xs-6 col-md-2 row items-center ">
        <h4 class="q-ma-xs col-8">Задачи</h4>
        <div v-if="$q.screen.gt.sm ? true : route.name === 'ProjectTasks'" class="col-2">
          <q-btn icon="filter_list" round color="primary" @click="filter = true"/>
          <q-dialog v-model="filter">
            <task-filters @apply="filter = false" @cancel="filter = false"/>
          </q-dialog>
        </div>
      </div>
      <div class="col-xs-12 col-md-8 text-right">
        <q-btn color="primary" :disable="selectedTasksCount === 0" label="Экспорт" @click="exportTasks"
               class="q-ma-xs"/>
        <q-btn color="primary" :disable="selectedTasksCount === 0" label="Копировать" @click="copyTasks"
               class="q-ma-xs"/>
        <q-btn
            v-if="canCreateTask"
            color="primary"
            label="Создать"
            :to="`/projects/${projectId}/tasks/new?page=${page}`"
            class="q-ma-xs"
        />
        <template v-if="canShowMoreActions">
          <q-btn-dropdown color="primary" label="Еще" class="q-ma-xs" no-caps>
            <q-list>
              <q-item v-if="canAdminWrite" clickable v-close-popup @click="updateTasks">
                <q-item-section>Обновить</q-item-section>
              </q-item>
              <q-item v-if="canPerformShift" clickable v-close-popup :disable="selectedTasksCount === 0"
                      @click="shiftTasks">
                <q-item-section>Сдвиг дат</q-item-section>
              </q-item>
              <q-item v-if="canAdminWrite" clickable v-close-popup :disable="selectedTasksCount === 0"
                      @click="deleteTasks">
                <q-item-section>Удалить</q-item-section>
              </q-item>
              <q-item v-if="canPerformShift" clickable v-close-popup :disable="selectedTasksCount === 0"
                      @click="changeDateTasks">
                <q-item-section>Смена даты</q-item-section>
              </q-item>
            </q-list>
          </q-btn-dropdown>
        </template>
      </div>
    </div>
    <div class="col-xs-10 col-md-11 row ">
      <div class="col-12 col-sm-3 q-pa-sm" v-if="$q.screen.gt.sm ? true : route.name === 'ProjectTasks'">
        <task-list ref="taskList" :project="projectId"/>
      </div>
      <q-scroll-area class="col-12 col-sm-9 full-height " v-if="$q.screen.gt.sm ? true : route.name !== 'ProjectTasks'">
        <router-view/>
      </q-scroll-area>
    </div>
  </q-page>
</template>

<script setup lang="ts">
import {useRoute} from "vue-router";
import TaskList from "../components/TaskList.vue";
import {computed, ref} from "vue";
import TaskFilters from "../components/TaskFilters.vue";
import {useQuasar} from "quasar";
import CreateReport from "../components/CreateReport.vue";
import CopyTasks from "../components/CopyTasks.vue";
import {useRouteQuery} from "@vueuse/router";
import UpdateTasks from "../components/UpdateTasks.vue";
import {storeToRefs} from "pinia";
import {useProjectStore} from "../store/project";
import DeleteTasks from "../components/DeleteTasks.vue";
import ShiftTasks from "../components/ShiftTasks.vue";
import ChangeDateTasks from "../components/ChangeDateTasks.vue";

const route = useRoute()
const projectStore = useProjectStore()
const {project} = storeToRefs(projectStore)
const $q = useQuasar()
const projectId = computed(() => Number(route.params.projectId))
const filter = ref(false)
const taskList = ref()
const page = useRouteQuery('page', '1', {transform: Number})
const selectedTasksCount = computed(() => taskList?.value?.selectedMainTasks?.length ?? 0)
const canAdminWrite = computed(() => project.value?.yourPermission === 'ADMINISTRATOR' || project.value?.yourPermission === 'WRITE')
const canPerformShift = computed(() => canAdminWrite.value || project.value?.yourPermission === 'PERFORMER')
const canCreateTask = computed(() => canAdminWrite.value)
const canShowMoreActions = computed(() => canAdminWrite.value || project.value?.yourPermission === 'PERFORMER')

function heightTweak(offset: number) {
  return {
    height: offset ? `calc(100vh - ${offset}px)` : '100vh',
    maxHeight: offset ? `calc(100vh - ${offset}px)` : '100vh'
  }
}

function exportTasks() {
  if (taskList.value.selectedMainTasks.length < 1) {
    return
  }
  $q.dialog({
    persistent: true,
    component: CreateReport,
    componentProps: {
      tasks: taskList.value.selectedMainTasks
    }
  })
}

function deleteTasks() {
  if (taskList.value.selectedMainTasks.length < 1) {
    return
  }
  $q.dialog({
    persistent: true,
    component: DeleteTasks,
    componentProps: {
      tasks: taskList.value.selectedMainTasks,
    }
  })
}

function copyTasks() {
  if (taskList.value.selectedMainTasks.length < 1) {
    return
  }
  $q.dialog({
    persistent: true,
    component: CopyTasks,
    componentProps: {
      tasks: taskList.value.selectedMainTasks
    }
  })
}


function updateTasks() {
  $q.dialog({
    persistent: true,
    component: UpdateTasks,
    componentProps: {
      tasks: taskList.value.selectedMainTasks
    }
  })
}

function shiftTasks() {
  if (taskList.value.selectedMainTasks.length < 1) {
    return
  }
  $q.dialog({
    persistent: true,
    component: ShiftTasks,
    componentProps: {
      tasks: taskList.value.selectedMainTasks
    }
  })
}

function changeDateTasks() {
  if (taskList.value.selectedMainTasks.length < 1) {
    return
  }
  $q.dialog({
    persistent: true,
    component: ChangeDateTasks,
    componentProps: {
      tasks: taskList.value.selectedMainTasks
    }
  })
}
</script>

<style scoped></style>
